import { Link } from 'react-router-dom';
import type { MangaItem } from '@/mocks/manga';

function MangaCard({ item }: { item: MangaItem }) {
  return (
    <Link
      to={`/article/${item.slug}`}
      className="group block overflow-hidden rounded-lg bg-background-100 transition-transform duration-300 hover:-translate-y-1"
      title={`${item.title} 漫画在线看`}
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden">
        <img
          src={item.cover}
          alt={`${item.title} 漫画封面`}
          title={`${item.title} 漫画`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span
          className={`absolute left-2 top-2 rounded-full px-2 py-0.5 text-xs font-bold text-background-50 ${
            item.status === 'finished' ? 'bg-secondary-500' : 'bg-primary-500'
          }`}
        >
          {item.status === 'finished' ? '完结' : '连载中'}
        </span>
        <span className="absolute bottom-2 right-2 rounded-full bg-foreground-950/70 px-2 py-0.5 text-xs text-background-50">
          <i className="ri-eye-line mr-1"></i>
          {(item.views / 10000).toFixed(1)}万
        </span>
      </div>
      <div className="p-3">
        <h3 className="truncate text-sm font-bold text-foreground-950 md:text-base">
          {item.title}
        </h3>
        <div className="mt-2 flex items-center gap-2">
          <span className="text-xs text-accent-700">
            <i className="ri-star-fill mr-0.5 text-accent-500"></i>
            {item.rating}
          </span>
          <span className="truncate text-xs text-foreground-600">{item.category}</span>
        </div>
      </div>
    </Link>
  );
}

export default MangaCard;